import React from 'react';

const Schedule = ({ timeline, rule }) => {
  return <div>Schedule</div>;
};
export default Schedule;
